import { render, staticRenderFns } from "./upload.vue?vue&type=template&id=e8455070&scoped=true"
import script from "./upload.vue?vue&type=script&lang=js"
export * from "./upload.vue?vue&type=script&lang=js"
import style0 from "./upload.vue?vue&type=style&index=0&id=e8455070&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8455070",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\project\\fashang\\cqykdx\\student_pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8455070')) {
      api.createRecord('e8455070', component.options)
    } else {
      api.reload('e8455070', component.options)
    }
    module.hot.accept("./upload.vue?vue&type=template&id=e8455070&scoped=true", function () {
      api.rerender('e8455070', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/uploadImg/upload.vue"
export default component.exports